<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@font-face {
  font-family: "Alibaba PuHuiTi 2.0 65 Medium";
  font-weight: 500;
  src: url("//at.alicdn.com/wf/webfont/vG4jmreHnxEW/FBqFW6229Vjv.woff2") format("woff2"),
  url("//at.alicdn.com/wf/webfont/vG4jmreHnxEW/3ErUl9BGlo8K.woff") format("woff");
  font-display: swap;
}

@font-face {
  font-family: "Alibaba PuHuiTi 2.0 105 Heavy";
  font-weight: 900;
  src: url("//at.alicdn.com/wf/webfont/vG4jmreHnxEW/aLJYLSucYqKg.woff2") format("woff2"),
  url("//at.alicdn.com/wf/webfont/vG4jmreHnxEW/7qmcTWW9rZHS.woff") format("woff");;
  font-display: swap;
}

html, body {
  margin: 0;
  padding: 0;
  border: 0;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100vw;
  max-width: 100vw;
  height: 100vh;
  max-height: 100vh;
  /* margin-top: 60px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue